export default class Guid {
	static newGuid(): string {
		return 'xxxxxxxx'.replace(/[xy]/g, function () {
			return '' + Math.floor(Math.random() * 10);
		});
	}
}
